// This icon file is generated automatically.
var PtoCirCheckCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M16 2a14 14 0 100 28 14 14 0 000-28zm6.05 9.43l-6.58 9.12a1 1 0 01-1.62 0l-3.9-5.4c-.12-.16 0-.4.2-.4h1.47a1 1 0 01.81.42l2.23 3.09 4.9-6.81a1 1 0 01.82-.42h1.46c.2 0 .33.23.2.4z", "fill-rule": "nonzero" } }] }, "name": "pto-cir-check-circle", "theme": "filled" };
export default PtoCirCheckCircleFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoCirCheckCircleFilled.js
// module id = 3889
// module chunks = 0